import React, { Component } from 'react';
import UploadFileContainer from './UploadFileContainer';
import { I18n } from 'react-redux-i18n-lite';
import { PropTypes } from 'prop-types';
import { getAsset } from '../../../services/assets/assetsService';
import { connect } from 'react-redux';
import ContentUploadBar from '../../ContentUploadBar/ContentUploadBar';
import { bindActionCreators } from 'redux';
import * as assignmentsDrawerActions from '../../../actions/assignmentsDrawerActions';

class FileEvaluationBox extends Component {
  static propTypes = {
    customer: PropTypes.object,
    task: PropTypes.any,
    student: PropTypes.any,
    onChangeFile: PropTypes.func,
    uploadingFile: PropTypes.bool,
    canChange: PropTypes.bool,
    uploadStatus: PropTypes.object,
    isEvaluated: PropTypes.bool,
    isInstructor: PropTypes.bool,
    isFirstTry: PropTypes.bool
  };

  static defaultProps = {
    uploadingFile: false
  };

  constructor(props) {
    super(props);

    this.state = {
      preloadFile: true,
      defaultFile: [],
      activeLoader: true
    };
  }

  componentDidMount() {
    this.getEvaluationFile();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.task.studentAttempts[this.props.student._id].evaluation &&
      prevProps.task.studentAttempts[this.props.student._id].evaluation.attachments &&
      prevProps.task.studentAttempts[this.props.student._id].evaluation.attachments !==
        this.props.task.studentAttempts[this.props.student._id].evaluation.attachments
    ) {
      this.getEvaluationFile();
    }
  }

  renderTitle() {
    return <span className="section-title-label">{I18n.t('panels.assignment.attachEvaluationFile')}</span>;
  }

  getEvaluationFile() {
    const { task, student, customer, isFirstTry } = this.props;

    const responses = task.studentAttempts[student._id].responses;
    let evaluation = task.studentAttempts[student._id].evaluation;

    if (responses && responses.length > 1) {
      const index = isFirstTry ? 0 : responses.length - 1;
      evaluation = responses[index].evaluation;
    }

    if (evaluation && evaluation.attachments && evaluation.attachments.length) {
      const getAssetPromises = evaluation.attachments.map(uuid => getAsset(uuid, customer.id));

      Promise.allSettled(getAssetPromises).then(res => {
        const okResponses = res.filter(r => r.status !== 'rejected');

        const fetchedFiles = okResponses.map(r => r.value.data);
        this.setState({
          defaultFile: fetchedFiles,
          activeLoader: false
        });
      });
    } else {
      this.setState({ activeLoader: false });
    }
  }

  onDelete(e, index) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const newFiles = [...this.state.defaultFile];
    const prevFiles = [...newFiles];
    newFiles.splice(index, 1);
    this.setState({
      defaultFile: newFiles
    });
    this.props.onChangeFile(newFiles, prevFiles);
  }

  onDropEvaluation = files => {
    const newFiles = [...this.state.defaultFile, ...files];
    const prevFiles = [...this.state.defaultFile];
    this.setState({
      defaultFile: newFiles
    });
    this.props.onChangeFile(newFiles, prevFiles);
  };

  render() {
    const { uploadStatus } = this.props;
    return (
      <div>
        <div className="content-task-container">
          {this.renderTitle()}

          <div style={{ marginTop: 24 }}>
            <UploadFileContainer
              disableClick={this.props.uploadingFile}
              defaultFile={this.state.defaultFile}
              onDeleteFile={(e, index) => this.onDelete(e, index)}
              showLoader={this.state.activeLoader}
              canChange={this.props.canChange}
              onDrop={newFiles => this.onDropEvaluation(newFiles)}
              isEvaluated={this.props.isEvaluated}
              isInstructor={this.props.isInstructor}
            />
            <ContentUploadBar percent={uploadStatus.percentCompleted} isUploading={uploadStatus.isUploading} />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    customer: state.school.school.customer,
    uploadStatus: state.assignmentsDrawerActions.uploadFileTaskStatus,
    i18n: state.i18n
  };
}
function mapDispatchToProps(dispatch) {
  return {
    assignmentsDrawerActions: bindActionCreators(assignmentsDrawerActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FileEvaluationBox);
